import _ from 'lodash';
import { store } from '../../../../store';

/**
 *
 * @name modifierServiceTypesToObject
 * @description Из массива сервис типов в объект
 * @returns {{}}
 */
export const modifierServiceTypesToObject = () => {
  const { services: { serviceTypes } } = store.getState();
  const types = {};
  serviceTypes.forEach((type) => {
    types[type.id] = {
      ...type,
    }
  });
  return types;
};

/**
 *
 * @name modifiersProvidersToObject
 * @description Список провайдеров в объект
 * @returns {object}
 */
export const modifiersProvidersToObject = () => {
  const { services: { providers } } = store.getState();
  if (_.isArray(providers) && providers.length) {
    return providers.reduce((obj, provider) => {
      obj[provider.id] = {
        ...provider,
      }
      return obj;
    }, {});
  }
  return {};
};
